// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"b24d0d80","209":"dd5bd9c2","717":"19f8a0ac","829":"8cff4214"}[chunkId] + ".chunk.js";
};